import { AnimatePresence, motion } from 'framer-motion'
import React from 'react'
import { Button } from '../../core/button/Button'
import s from './BackToTop.module.scss'

// This function will scroll the window to the top
const scrollToTop = () => {
    window.scroll({
        top: 0,
        behavior: 'smooth',
    })
}

type Props = {
    row: number
    column: number
    span: number
    isActive?: boolean
}

const BackToTop = ({ row, span, column, isActive }: Props) => {
    return (
        // TODO: ts ignore
        // @ts-ignore
        <AnimatePresence>
            {isActive && (
                <motion.div
                    className={s.backToTop}
                    style={{
                        gridColumn: column,
                        gridRowStart: row,
                        gridRowEnd: `span ${span}`,
                    }}
                    initial={{ transform: 'translateY(0%)', opacity: 0 }}
                    animate={{
                        transform: 'translateY(0%)',
                        opacity: 1,
                        transition: {
                            delay: 0,
                            duration: 0.5,
                        },
                    }}
                    exit={{ opacity: 0 }}
                >
                    <div className={s.backToTop__button} onClick={scrollToTop}>
                        <Button
                            className={s.button}
                            variant="arrow"
                            arrowDirection="u"
                        />
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    )
}

export default BackToTop
